import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768; // matches Tailwind `md`

/**
 * Returns true when the viewport is narrower than the `md` breakpoint (768px).
 * Uses matchMedia so it reacts to window resizes without polling.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth < MOBILE_BREAKPOINT,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
